import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types'; 
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { RequestService } from 'services/RequestService';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelect({ adminIds, onChange,  }) { 
  const theme = useTheme();
  const [selectedAdmins, setSelectedAdmins] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await RequestService.get("/Auth/get-all-users/?userType=6");
        if (response.data && !response.data.error) {
          setUsers(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    setSelectedAdmins(adminIds || []);
  }, [adminIds]);
  

  const handleChange = (event) => {
    const { value } = event.target;
    setSelectedAdmins(value);
    onChange(value);
  };

  return (
    <FormControl sx={{ width: '100%', height: 46 }}>
      <InputLabel id="demo-multiple-name-label">المدراء</InputLabel>
      <Select
        labelId="demo-multiple-name-label"
        id="demo-multiple-name"
        multiple
        sx={{ width: '100%', height: 60 }}
        value={selectedAdmins}
        onChange={handleChange}
        input={<OutlinedInput label="المدراء" />}
        MenuProps={MenuProps}
      >
        {users.map((user) => (
          <MenuItem key={user.id} value={user.id}>
            {user.displayName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

MultipleSelect.propTypes = {
  adminIds: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};
